import { useEffect, useRef, useState } from "react";
import { postAxios } from "../../util/apiCall";
import { today } from "../../util/formatDate";
import { Html5Qrcode } from "html5-qrcode";
import { constantChecklistPunching } from "../../util/constant";

export const usePatrolSp = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const html5QrCodeRef = useRef(null);

  const [subMenu, setSubMenu] = useState("monitoring");
  const [checlistPunching, setChecklistPunching] = useState(
    constantChecklistPunching
  );

  const [popUpQrDokumen, setPopUpQrDokumen] = useState(false);
  const [popUpQrMesin, setPopUpQrMesin] = useState(false);
  const [popUpQrProduk, setPopUpQrProduk] = useState(false);
  const [popUpQrScreen, setPopUpQrScreen] = useState(false);

  const [dokumen, setDokumen] = useState("");
  const [screen, setScreen] = useState("");
  const [mesin, setMesin] = useState("");
  const [produk, setProduk] = useState("");

  const [tipe, setTipe] = useState("");
  const [dimensi, setDimensi] = useState(null);
  const [inputUser, setInputUser] = useState({});
  const [error, setError] = useState({});

  const [popUpTambahDokumen, setPopUpTambahDokumen] = useState(false);

  const [form, setForm] = useState({
    dimensiPrint: {
      bawah: {},
      kiri: {},
      atas: {},
      kanan: {},
    },
    dimensiSticker: {
      bawah: {},
      kiri: {},
      atas: {},
      kanan: {},
    },
  });
  const [addNewDokumenCustomer, setAddNewDokumenCustomer] =
    useState("Customer");
  const [addNewDokumenProduk, setAddNewDokumenProduk] = useState("");
  const [addNewDokumen, setAddNewDokumen] = useState("");
  const [addNewDokumenScreen, setAddNewDokumenScreen] = useState("");
  const [isRefresh, setIsRefresh] = useState(false);

  const [filterCustomer, setFilterCustomer] = useState("Customer");
  const [listDataValidasi, setListDataValidasi] = useState();

  const [tipePatrol, setTipePatrol] = useState();

  const [jumlahSampling, setJumlahSampling] = useState();
  const [dataReject, setDataReject] = useState([]);
  const [dateReject, setDateReject] = useState(today);
  const [bagianReject, setBagianReject] = useState("");
  const [rejectDescProduksi, setRejectDescProduksi] = useState();
  const [rejectPick, setRejectPick] = useState("");
  const [shiftProduksi, setShiftProduksi] = useState("Pilih Shift");
  const [jumlahReject, setJumlahReject] = useState("");
  const [alasanRejectSP, setAlasanRejectSP] = useState("Pilih Alasan");

  const [addPopUpNewReject, setAddPopUpNewReject] = useState(false);

  const [dataMonitoring, setDataMonitoring] = useState([]);

  const [filterDate, setFilterDate] = useState(today);

  const [filterJenis, setFilterJenis] = useState("Pilih Jenis");
  const [filterMesin, setFilterMesin] = useState("Pilih Mesin");
  const [filterProduk, setFilterProduk] = useState("Pilih Produk");

  const hasError = Object.values(error).some(Boolean);

  useEffect(() => {
    setMesin("");
    setProduk("");
    const resetChecklist = constantChecklistPunching.map((item) => ({
      ...item,
      isChecked: false,
      isTrouble: false,
    }));

    setChecklistPunching(resetChecklist);
  }, [tipe]);

  const handleChangeChecklistPunching = (index, type) => {
    let data = [...checlistPunching];

    if (type === "check") {
      if ((data[index][`isChecked`] = true)) {
        data[index][`isTrouble`] = false;
        data[index][`isChecked`] = true;
      } else {
        data[index][`isTrouble`] = true;
        data[index][`isChecked`] = false;
      }
    } else {
      if ((data[index][`isTrouble`] = true)) {
        data[index][`isTrouble`] = true;
        data[index][`isChecked`] = false;
      } else {
        data[index][`isTrouble`] = false;
        data[index][`isChecked`] = true;
      }
    }

    setChecklistPunching(data);
  };

  const handleScanDokumen = () => {
    if (popUpQrDokumen) {
      if (!html5QrCodeRef.current) {
        html5QrCodeRef.current = new Html5Qrcode("qr");
      }

      const html5QrCode = html5QrCodeRef.current;

      const qrCodeSuccessCallback = async (decodedText) => {
        if (decodedText) {
          html5QrCode.pause();

          setDokumen(decodedText);
          setPopUpQrDokumen(false);

          html5QrCode.stop().then(() => {
            html5QrCode.clear();
            html5QrCodeRef.current = null;
          });
        } else {
          html5QrCode.stop().then(() => {
            html5QrCode.clear();
            html5QrCodeRef.current = null;
          });
        }
      };
      const onScanFailed = (err) => {
        // console.log(err);
      };
      const config = { fps: 10, qrbox: { width: 250, height: 250 } };
      html5QrCode.start(
        { facingMode: "environment" },
        config,
        qrCodeSuccessCallback,
        onScanFailed
      );
    }
  };

  const handleScanScreen = () => {
    if (popUpQrScreen) {
      if (!html5QrCodeRef.current) {
        html5QrCodeRef.current = new Html5Qrcode("qr-screen");
      }

      const html5QrCode = html5QrCodeRef.current;

      const qrCodeSuccessCallback = async (decodedText) => {
        if (decodedText) {
          html5QrCode.pause();

          setScreen(decodedText);
          setPopUpQrScreen(false);

          html5QrCode.stop().then(() => {
            html5QrCode.clear();
            html5QrCodeRef.current = null;
          });
        } else {
          setPopUpQrScreen(false);
          html5QrCode.stop().then(() => {
            html5QrCode.clear();
            html5QrCodeRef.current = null;
          });
        }
      };
      const onScanFailed = (err) => {
        // console.log(err);
      };
      const config = { fps: 10, qrbox: { width: 250, height: 250 } };
      html5QrCode.start(
        { facingMode: "environment" },
        config,
        qrCodeSuccessCallback,
        onScanFailed
      );
    }
  };

  const handleScanMesin = () => {
    if (popUpQrMesin) {
      if (!html5QrCodeRef.current) {
        html5QrCodeRef.current = new Html5Qrcode("qr-mesin");
      }

      const html5QrCode = html5QrCodeRef.current;

      const qrCodeSuccessCallback = async (decodedText) => {
        if (decodedText) {
          html5QrCode.pause();

          setMesin(decodedText);
          setPopUpQrMesin(false);

          html5QrCode.stop().then(() => {
            html5QrCode.clear();
            html5QrCodeRef.current = null;
          });
        } else {
          setPopUpQrMesin(false);
          html5QrCode.stop().then(() => {
            html5QrCode.clear();
            html5QrCodeRef.current = null;
          });
        }
      };
      const onScanFailed = (err) => {
        // console.log(err);
      };
      const config = { fps: 10, qrbox: { width: 250, height: 250 } };
      html5QrCode.start(
        { facingMode: "environment" },
        config,
        qrCodeSuccessCallback,
        onScanFailed
      );
    }
  };

  const handleScanProduk = () => {
    if (popUpQrProduk) {
      if (!html5QrCodeRef.current) {
        html5QrCodeRef.current = new Html5Qrcode("qr-produk");
      }

      const html5QrCode = html5QrCodeRef.current;

      const qrCodeSuccessCallback = async (decodedText) => {
        if (decodedText) {
          html5QrCode.pause();

          setProduk(decodedText);
          setPopUpQrProduk(false);

          html5QrCode.stop().then(() => {
            html5QrCode.clear();
            html5QrCodeRef.current = null;
          });
        } else {
          setPopUpQrProduk(false);
          html5QrCode.stop().then(() => {
            html5QrCode.clear();
            html5QrCodeRef.current = null;
          });
        }
      };
      const onScanFailed = (err) => {
        // console.log(err);
      };
      const config = { fps: 10, qrbox: { width: 250, height: 250 } };
      html5QrCode.start(
        { facingMode: "environment" },
        config,
        qrCodeSuccessCallback,
        onScanFailed
      );
    }
  };

  useEffect(() => {
    if (popUpQrDokumen) {
      handleScanDokumen();
    }
    if (popUpQrMesin) {
      handleScanMesin();
    }
    if (popUpQrScreen) {
      handleScanScreen();
    }
    if (popUpQrProduk) {
      handleScanProduk();
    }
  }, [popUpQrDokumen, popUpQrMesin, popUpQrProduk, popUpQrScreen]);

  const handleCloseScan = () => {
    const html5QrCode = html5QrCodeRef.current;
    if (html5QrCode) {
      html5QrCode
        .stop()
        .then(() => {
          html5QrCode.clear();
          html5QrCodeRef.current = null;
        })
        .catch((err) => {
          console.log("Error stopping qr code", err);
        });
    }
  };

  useEffect(() => {
    if (subMenu === "data") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getDataDokumenSp`,
        {
          tim: dataUser.tim,
          customer: filterCustomer,
        },
        dataUser.auth,
        setListDataValidasi,
        ""
      );
      setIsRefresh(false);
    } else if (subMenu === "validasi") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getDataDokumenSp`,
        {
          tim: dataUser.tim,
          type: "validasi",
        },
        dataUser.auth,
        setListDataValidasi,
        ""
      );
      setIsRefresh(false);
    } else if (subMenu === "patrol") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getListPerincian`,
        {},
        dataUser.auth,
        setRejectDescProduksi,
        ""
      );
      setIsRefresh(false);
    } else if (subMenu === "monitoring") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getListMonitoring`,
        {
          tim: dataUser.tim,
          filterDate: filterDate,
          type: filterJenis !== "Pilih Jenis" ? filterJenis : "",
        },
        dataUser.auth,
        setDataMonitoring,
        ""
      );
      setIsRefresh(false);
    }
  }, [filterCustomer, isRefresh, subMenu, filterDate, filterJenis]);

  const getDimensi = (dokumen, screenName, tipe) => {
    if (tipe === "punching") {
      return {};
    }

    const item =
      listDataValidasi &&
      listDataValidasi.find(
        (x) => x.dokumen === dokumen && x.screen === screenName
      );

    if (!item) return {};

    if (tipe === "pasang sticker") {
      return item.dimensiSticker ? { ...item.dimensiSticker } : {};
    }

    if (tipe === "print") {
      return item.dimensiPrint ? { ...item.dimensiPrint } : {};
    }

    return {};
  };

  const handleChange = (posisi, value) => {
    const number = Number(value);

    setInputUser((prev) => ({
      ...prev,
      [posisi]: number,
    }));

    const spec = dimensi?.[posisi];

    if (!spec || spec.ukuran === undefined) return;

    const toleransiAtas = spec.toleransiAtas ?? 0;
    const toleransiBawah = spec.toleransiBawah ?? 0;

    const min = spec.ukuran - toleransiBawah;
    const max = spec.ukuran + toleransiAtas;

    let err = "";

    if (toleransiAtas === 0 && toleransiBawah === 0) {
      if (number !== spec.ukuran) {
        err = `Harus sama dengan ${spec.ukuran}`;
      }
    } else {
      if (number < min || number > max) {
        err = `Harus antara ${min} - ${max}`;
      }
    }

    setError((prev) => ({
      ...prev,
      [posisi]: err,
    }));
  };

  useEffect(() => {
    if (dokumen && screen && tipe) {
      const result = getDimensi(dokumen, screen, tipe);

      setDimensi(result);
      setInputUser({});
      setError({});
    }
  }, [dokumen, screen, tipe]);

  const isChecklistValid = () => {
    return checlistPunching.every((item) => item.isChecked || item.isTrouble);
  };

  const handleKirimValidasi = () => {
    const itemName =
      listDataValidasi && listDataValidasi.find((x) => x.dokumen === dokumen);
    if (
      !hasError &&
      Object.keys(inputUser).length !== 0 &&
      tipe !== "punching"
    ) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/validasiAwalSp`,
        {
          tim: dataUser.tim,
          petugas: dataUser.name,
          produk: itemName.nama,
          type: tipe,
          dokumen: dokumen,
          screen: screen,
          inputUser: inputUser,
        },
        dataUser.auth,
        "",
        ""
      );
      setScreen("");
      setDokumen("");
      setInputUser({});
      setDimensi(null);
    } else if (isChecklistValid() && mesin && produk) {
      let isMesinPrinting = /mesin/i.test(mesin ?? "");
      let checkProduk = /mesin/i.test(produk ?? "");

      if (isMesinPrinting && !checkProduk) {
        postAxios(
          `${process.env.REACT_APP_ENDPOINT}/validasiAwalSp`,
          {
            tim: dataUser.tim,
            petugas: dataUser.name,
            type: tipe,
            checklistPunching: checlistPunching,
            mesin: mesin,
            produk: produk,
          },
          dataUser.auth,
          "",
          ""
        );
        setMesin("");
        setProduk("");
        const resetChecklist = constantChecklistPunching.map((item) => ({
          ...item,
          isChecked: false,
          isTrouble: false,
        }));

        setChecklistPunching(resetChecklist);
        setError({});
      } else {
        if (!isMesinPrinting) {
          setError((prev) => ({
            ...prev,
            mesin: true,
          }));
        }
        if (checkProduk) {
          setError((prev) => ({
            ...prev,
            produk: true,
          }));
        }
      }
    }
  };

  const handleChangeAddNewDokumen = (section, posisi, field, value) => {
    setForm((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [posisi]: {
          ...prev[section][posisi],
          [field]: Number(value),
        },
      },
    }));
  };

  const handleKirimAddNewDokumen = () => {
    if (
      addNewDokumenCustomer !== "Customer" &&
      addNewDokumenProduk &&
      addNewDokumen &&
      addNewDokumenScreen
    ) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/addNewDataDokumenSp`,
        {
          tim: dataUser.tim,
          customer: addNewDokumenCustomer,
          nama: addNewDokumenProduk,
          dokumen: addNewDokumen,
          data: [
            {
              screen: addNewDokumenScreen,
              dimensiPrint: form.dimensiPrint,
              dimensiSticker: form.dimensiSticker,
            },
          ],
        },
        dataUser.auth,
        "",
        ""
      );
      setAddNewDokumenCustomer("Customer");
      setAddNewDokumenProduk("");
      setAddNewDokumen("");
      setAddNewDokumenScreen("");
      setForm({
        dimensiPrint: {
          bawah: {},
          kiri: {},
          atas: {},
          kanan: {},
        },
        dimensiSticker: {
          bawah: {},
          kiri: {},
          atas: {},
          kanan: {},
        },
      });
      setIsRefresh(true);
    }
  };

  const renderDimensi = (data) => {
    if (!data) return "-";

    const result = Object.entries(data)
      .map(([key, value]) => {
        if (value && value.ukuran !== undefined) {
          return (
            <div key={key}>
              <strong>{key}</strong>: {value.ukuran}
              {value.toleransiAtas !== undefined &&
                ` (+${value.toleransiAtas})`}
              {value.toleransiBawah !== undefined &&
                ` (-${value.toleransiBawah})`}
            </div>
          );
        }
        return null;
      })
      .filter(Boolean);

    return result.length > 0 ? result : "-";
  };

  let dataSelect = [];

  rejectDescProduksi &&
    rejectDescProduksi.forEach((element) => {
      dataSelect.push({ value: element.id, label: element.desc });
    });

  const handlePickBagian = (data) => {
    setBagianReject(data);
    if (data === "SP") {
      setJumlahReject("");
      setAlasanRejectSP("Pilih Alasan");
    } else if (data === "Produksi") {
      setShiftProduksi("Pilih Shift");
      setJumlahReject("");
    }
  };

  const addFields = () => {
    if (bagianReject === "SP") {
      let newfield = {
        dateReject: dateReject,
        id: alasanRejectSP,
        reject: jumlahReject,
        bagian: "SP",
      };
      setDataReject([...dataReject, newfield]);
    } else if (bagianReject === "Produksi") {
      let newfield = {
        dateReject: dateReject,
        id: rejectPick.label,
        shift: shiftProduksi,
        reject: jumlahReject,
        bagian: "Produksi",
      };
      setRejectPick("");
      setDataReject([...dataReject, newfield]);
    }
    setAddPopUpNewReject(false);
    setShiftProduksi("Pilih Shift");
    setJumlahReject("");
    setAlasanRejectSP("Pilih Alasan");
    setBagianReject("");
  };

  const removeFields = () => {
    let data = [...dataReject];
    if (data.length > 0) {
      data.splice(data.length - 1);
      setDataReject(data);
    }
  };

  const handleKirimPatrol = () => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/addNewDataPatrol`,
      {
        tim: dataUser.tim,
        petugas: dataUser.name,
        mesin: mesin,
        produk: produk,
        type: "patrol",
        jenisPatrol: tipePatrol,
        kindOfReject: dataReject,
        jumlahSampling: Number(jumlahSampling),
      },
      dataUser.auth,
      "",
      ""
    );
    setJumlahSampling();
    setDataReject([]);
    setMesin("");
    setProduk("");
  };

  const getProdukList = (data) => {
    const produkSet = new Set();

    data.forEach((item) => {
      const value = item.produk || item.name; // ⬅️ wajib
      if (value) produkSet.add(value);
    });

    return Array.from(produkSet);
  };

  const getMesinList = (data) => {
    const mesinSet = new Set();

    data.forEach((item) => {
      if (item.mesin) mesinSet.add(item.mesin);
    });

    return Array.from(mesinSet);
  };

  const listProduk = getProdukList(dataMonitoring && dataMonitoring);
  const listMesin = getMesinList(dataMonitoring && dataMonitoring);
  const filterData = (data) => {
    const isActive = (val, label) => {
      return val && val !== label;
    };

    const matchRegex = (value, keyword) => {
      if (!keyword) return true;

      const safeKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      return new RegExp(safeKeyword, "i").test(value || "");
    };

    return data.filter((item) => {
      // 1. filter jenis (optional)
      if (isActive(filterJenis, "Pilih Jenis")) {
        if (item.type !== filterJenis.toLowerCase()) return false;
      }

      // 2. filter mesin (optional, semua type boleh kena)
      if (isActive(filterMesin, "Pilih Mesin")) {
        if (!matchRegex(item.mesin, filterMesin)) return false;
      }

      // 3. filter produk (optional, semua type boleh kena)
      if (isActive(filterProduk, "Pilih Produk")) {
        const target = item.produk || item.name;
        if (!matchRegex(target, filterProduk)) return false;
      }

      return true;
    });
  };

  const filteredData = filterData(dataMonitoring && dataMonitoring);

  return {
    dataUser,
    subMenu,
    setSubMenu,
    checlistPunching,
    handleChangeChecklistPunching,
    popUpQrDokumen,
    setPopUpQrDokumen,
    popUpQrMesin,
    setPopUpQrMesin,
    handleCloseScan,
    mesin,
    produk,
    popUpQrProduk,
    setPopUpQrProduk,
    popUpQrScreen,
    setPopUpQrScreen,

    dokumen,
    setTipe,
    dimensi,
    inputUser,
    handleChange,
    error,
    screen,
    tipe,
    handleKirimValidasi,
    hasError,
    mesin,
    produk,
    isChecklistValid,
    popUpTambahDokumen,
    setPopUpTambahDokumen,
    handleChangeAddNewDokumen,
    addNewDokumenCustomer,
    setAddNewDokumenCustomer,
    addNewDokumenProduk,
    setAddNewDokumenProduk,
    addNewDokumen,
    setAddNewDokumen,
    addNewDokumenScreen,
    setAddNewDokumenScreen,
    handleKirimAddNewDokumen,
    filterCustomer,
    setFilterCustomer,
    listDataValidasi,
    renderDimensi,
    tipePatrol,
    setTipePatrol,
    dataReject,
    addPopUpNewReject,
    setAddPopUpNewReject,
    dateReject,
    setDateReject,
    bagianReject,
    dataSelect,
    rejectPick,
    setRejectPick,
    shiftProduksi,
    setShiftProduksi,
    jumlahReject,
    setJumlahReject,
    alasanRejectSP,
    setAlasanRejectSP,
    addFields,
    handlePickBagian,
    removeFields,
    jumlahSampling,
    setJumlahSampling,
    handleKirimPatrol,
    filterJenis,
    setFilterJenis,
    filterDate,
    setFilterDate,
    filteredData,
    listProduk,
    listMesin,
    filterMesin,
    setFilterMesin,
    filterProduk,
    setFilterProduk,
  };
};
